import * as React from 'react'
import styles from './ReturnPolicy.module.scss'
import { inject, observer } from 'mobx-react'

import { PropsWithInjectedRootStore } from 'constants/types'
import { LegalWrapper } from 'components/LegalWrapper'
import { Button } from 'components/Phantom/Button/Button'
import { getPhoneNumber } from './utils'

export const ReturnPolicy = (props: PropsWithInjectedRootStore) => {
	const regionSellsMattress = props.rootStore.productStore.regionSellsMattress()
	const regionSellsBundle = props.rootStore.productStore.regionSellsBundle()
	const region = props.rootStore.settingsStore.currentRegion
	const phoneNumber = getPhoneNumber(region)
	const chevronSrc = 'https://eightsleep.imgix.net/chevron_gray.svg?v=1647501707'
	const SubHeader = () => (
		<>
			<div className={styles.contact_text}>
				Contact us at support@eightsleep.com or <br /> 888-699-4015 with your order number and our Sleep Pros
				<br /> will be happy to assist you with the next steps.
			</div>
			<div
				className={styles.contact_cta}
				id="return_float"
			>
				<Button.White
					id="contact_cta"
					href={'mailto:support@eightsleep.com'}
				>
					Contact us
				</Button.White>
				<a
					className={styles.phone_link}
					href={phoneNumber.link}
				>
					<small>{phoneNumber.string}</small>
				</a>
			</div>
		</>
	)
	return (
		<LegalWrapper
			mainTitle="Returning a product?"
			heroSrc="https://eightsleep.imgix.net/assets/return_policy_hero.png"
			includeContact={true}
			subHeaderElement={SubHeader()}
			showChevron={false}
		>
			{regionSellsMattress && (
				<>
					<h2 id="start">Pod Mattress Return Policy</h2>
					<hr />
					<p>
						Any Pod Mattress can be returned within 30 days of the delivery date without return shipping charges. To ensure the integrity and sanitary standard of our products, Eight Sleep does not
						re-use or offer refurbished foam and hence, does not take back the mattress portion. Instead, our team will work with you to donate, recycle, or dispose of the mattress.
					</p>
					<h3 id="q1">Is there a cost for return shipping?</h3>
					<p>
						No. Any Pod Mattress can be returned within 30 days of the delivery date without shipping charges. To ensure the integrity and sanitary standard of our products, Eight Sleep does not
						re-use or offer refurbished beds, does not take back the mattresses. Instead, our team will work with you to donate, recycle, or dispose of the mattress.
					</p>
					<h3 id="q2">How do I return my Pod Mattress?</h3>
					<p>
						Email us at <a href="mailto: support@eightsleep.com">support@eightsleep.com</a> with your Order Number and return reason and our support team will be happy to assist you with the next
						steps.
					</p>
					<h3 id="q3">Can I return only one piece of the Pod Mattress?</h3>
					<p>
						At this time, customers who have purchased the Pod Mattress may request a partial return to either keep the technology bundle or the mattress portion. *Promotional items may need to be
						returned, in some cases.
					</p>
				</>
			)}
			<h2 id="coverReturn">Pod Cover Return Policy</h2>
			<hr />
			<p>Any Pod Cover can be returned within 30 days of the delivery date without return shipping charges.</p>

			{regionSellsBundle ? (
				<>
					<div className={styles.title_container}>
						<h2 id="accessories">Accessories Return Policy</h2>
						<hr />
						<p>
							Most accessories can be returned within 30 days of the delivery date without shipping charges.
							<br />
							<br />
							<i>*The Prince Bedframe has its own policy (see below).</i>
							<br />
							<i>**The 30 day trial period for accessories is not extended if purchased with a Pod or Pod 3.</i>
						</p>
					</div>

					<div className={styles.title_container}>
						<h2 id="bedfram">Prince Bedframe Policy</h2>
						<hr />
						<p>
							If you are unhappy with your purchase for any reason, and the item is unopened, you may submit a return request within 30 days of the delivery date, per the terms below.
							<br />
							<br />
							Terms:
						</p>

						<ul>
							<li>Products must be returned in their original packaging and received in like-new condition.</li>
							<li>Opened and/or used items will be &apos;Final Sale&apos; and are not returnable.</li>
							<li>Damaged items will not be accepted.</li>
							<li>Products shipped outside the contiguous United States are not returnable.</li>
							<li>If there is damage upon delivery, the white glove service must be notified before they leave.</li>
						</ul>
					</div>
				</>
			) : (
				<></>
			)}
		</LegalWrapper>
	)
}

export default inject('rootStore')(observer(ReturnPolicy))
